<div class="container">
  <div class="col-md-12 col-xs-12 col-sm-12 heading p-0 mt-4 mb-3">
    <span class="span-create-edit-hoshin color">EVENT SURVEY</span>
    <span class="pt-2" style="font-size: 12px;"><a href="assets/userguides/EventSurveyUserGuide.pdf" download class="pl-3 download-link">User Guide</a></span>
 </div>
  <div class= "top-section">
    <h4>CREATE SURVEY - {{eventName}}</h4>
  </div> 

  <div class="col-md-6 inlineFlex">
    <label for="registrationStartDate" class="control-label col-md-3 paddingLeft">Start Date <span class="star"> *</span></label>
    <div class="col-md-9 paddingLeftResp"><input class="form-control input-lg date-icon " placeholder="Select survey start date"
            id="date" name="date" type="text" bsDatepicker autocomplete="off" [(ngModel)]="surveyStartDate" [minDate]="RegMinDate" (onShown)="onShowPicker($event)">
    </div>
</div>

<div class="col-md-6 inlineFlex paddingRight">
    <label for="registrationEndDate" class="control-label col-md-3 paddingLeft">End Date <span class="star"> *</span></label>
    <div class="col-md-9 paddingLeftResp"><input class="form-control input-lg date-icon" placeholder="Select survey end date"
            id="date" name="date" type="text" bsDatepicker autocomplete="off"  [(ngModel)]="surveyEndDate" [minDate]="RegMinDate" (onShown)="onShowPicker($event)">
    </div>
</div>
<div id="comment" class="col-md-12 inlineFlex">
  <span class="col-md-2">Description</span>
  <textarea class="form-control col-md-10" rows="3" id="desc" name="surveyDesc"  [(ngModel)]="surveyDesc"placeholder="Survey description here"></textarea>
</div>
<div class="clear paddingBottom"></div>

  

    <table class="table table-striped" aria-describedby="table">
        <thead>
            <tr>
              <th scope="col" class="text-center" (click)="selectAllQuestions()">Select All</th>
              <th scope="col">Questions</th>
            </tr>
          </thead>
          <tbody>
              <tr *ngFor="let questions of distQAList">
                <td class="text-center">
                  <label for="defaultQuestCheckbox" id="defaultQuest" *ngIf="questions.default == true">
                    <input type="checkbox" id="defaultQuestCheckbox" required name="check" [checked]="questions.checked" (change)="toggleCheckboxBpg($event, questions)">
                    <span class="label-text"></span>
                  </label>                  
                  <label for="noDefaultQuestCheckbox" id="noDefaultQuest" *ngIf="questions.default == false">
                    <input type="checkbox" id="noDefaultQuestCheckbox" required name="check" [checked]="questions.checked" (change)="toggleCheckboxBpg($event, questions)">
                    <span class="label-text"></span>
                  </label>                  
                </td>
                <td>{{questions.question}}</td>                
              </tr>
          </tbody>  
    </table>
    <p class="top-space text-center">
        <span class="errorMessage" *ngIf="startDateError"> Please select start date </span>  
        <span class="errorMessage" *ngIf="endDateError"> Please select end date </span>
        <span class="errorMessage" *ngIf="dateRangeError"> Start date is greater than end date </span>
    </p>
    <p class="text-center">
       <button id="previewButton" type="button"  class="btn btn-danger col-sm-2 col-md-2 button-margin" (click)="preview()">PREVIEW</button>
    <span class="col-md-1"></span>
    <button type="button" class="btn btn-danger col-sm-2 col-md-2 button-margin" (click)="cancelClick()" data-toggle="modal" data-target="#myModal" >CANCEL</button>
      <app-confirmation-modal [PData]="msg1" (emitPass)="this[previewMethod]()" id ="1"></app-confirmation-modal>
    </p> 
   
   

   </div>

